<gc-text [variant]="'information'" [textColor]="'secondary'">{{
  'traceIdComponent.message' | translate
}}</gc-text>
<app-copy-string
  [value]="traceId()"
  [label]="'traceIdComponent.traceId' | translate"
  [successMessage]="'traceIdComponent.copiedTraceId' | translate"
></app-copy-string>
